import React, { useEffect, useState } from "react";
import styles from "./UserProfile.module.css";
import { useGetUserInquiryListQuery } from "../../store/api/profileApi";
import Pagination from "rc-pagination";
import diamondDummy from "../../assets/diamonds/diamond_round.png";
import { useGetSingleInquiryQuery } from "../../store/api/cartApi";
import ModalPopup from "../../components/ModelPopup";
import InquiryModelDetails from "./InquiryModelDetails";

const InquireyDetails = () => {
  const [pageNumber, serPageNumber] = useState(1);
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const {
    data: inquiryList,
    isLoading: inquiryListLoading,
    isFetching: inquiryListFetching,
  } = useGetUserInquiryListQuery(pageNumber);

  const handlePageChange = (e) => {
    serPageNumber(e);
  };

  useEffect(() => {
    return () => {
      setSelectedInquiry(null);
    };
  }, []);

  return (
    <div>
      <div>
        {inquiryList?.inquiryList.length === 0 ? (
          <p>Your haven't done any inquiry yet'.</p>
        ) : (
          <ul className={styles.cartList}>
            {inquiryList?.inquiryList?.map((item, idx) => (
              <li
                key={idx}
                className={styles.cartItem}
                onClick={() => setSelectedInquiry(item?.id)}
              >
                <img
                  src={diamondDummy}
                  alt={item.title}
                  className={styles.cartImage}
                />
                <div>
                  <div className={styles.cartTitle}>
                    Created at : {item.created_at}
                  </div>
                  <div className={styles.cartDesc}>
                    Item Count : {item.item_count}
                  </div>
                  <div className={styles.price}>${item?.total_price}</div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      {!inquiryListLoading && inquiryList?.inquiryCount > 10 && (
        <div className="pagination">
          <Pagination
            total={inquiryList?.inquiryCount}
            current={pageNumber}
            onChange={handlePageChange}
          />
        </div>
      )}
      <ModalPopup
        isOpen={selectedInquiry}
        onClose={() => setSelectedInquiry(null)}
      >
        <InquiryModelDetails selectedInquiry={selectedInquiry} />
      </ModalPopup>
    </div>
  );
};

export default InquireyDetails;
